<div
  class="notif-panel rounded-xl bg-white dark:bg-coal-500 border border-gray-300 dark:border-gray-700 shadow-lg"
  role="dialog"
  aria-label="Notifications"
  (click)="$event.stopPropagation()"
>
  <div class="notif-panel__header">
    <span class="notif-panel__title">Notifications</span>
    @if (unreadCount > 0) {
      <span class="notif-panel__count">{{ unreadCount }} new</span>
    }
    @if (unreadCount > 0) {
      <button class="notif-panel__read-all" (click)="markAllRead()">
        Mark all read
      </button>
    }
  </div>

  <div class="notif-panel__list">
    @if (notifications.length === 0) {
      <div class="notif-panel__empty">
        <img
          src="assets/icons/ui/bell.svg"
          alt=""
          width="28"
          height="28"
          class="notif-panel__empty-icon"
        />
        <p class="text-gray-600 dark:text-gray-400">You're all caught up</p>
      </div>
    }

    @for (n of notifications; track n.id) {
      <div
        class="notif-item"
        [class.notif-item--unread]="!n.read"
        [class.notif-item--warning]="n.type === 'warning'"
        [class.notif-item--error]="n.type === 'error'"
        [class.notif-item--success]="n.type === 'success'"
      >
        <div class="notif-item__dot"></div>

        <div class="notif-item__body">
          @if (n.appLabel) {
            <span class="notif-item__app">{{ n.appLabel }}</span>
          }
          <p class="notif-item__title">
            @if (n.link) {
              <a [routerLink]="n.link" (click)="navigate(n)">{{ n.title }}</a>
            } @else {
              {{ n.title }}
            }
          </p>
          <p class="notif-item__msg">{{ n.message }}</p>
          <span class="notif-item__time">{{ timeAgo(n.timestamp) }}</span>
        </div>

        <div class="notif-item__actions">
          @if (!n.read) {
            <button
              class="notif-item__mark-read"
              (click)="markRead(n)"
              title="Mark as read"
            >
              <span class="sr-only">Mark as read</span>
              <span class="notif-item__read-dot"></span>
            </button>
          }
          <button
            class="notif-item__dismiss"
            (click)="dismiss(n)"
            title="Dismiss"
          >
            ×
          </button>
        </div>
      </div>
    }
  </div>

  <div class="notif-panel__footer flex justify-between items-center">
    <a
      routerLink="/eciso/notifications"
      (click)="close.emit()"
      class="notif-panel__settings-link text-gray-700 dark:text-gray-300"
    >
      View all notifications →
    </a>
  </div>
</div>
